import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/blocks/pricing/index.tsx");
